<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.9,15.6C20.8,15.2,20.4,15,20,15h-4c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.6l-2.3,2.3c-0.3,0.3-0.4,0.7-0.2,1.1 c0.2,0.4,0.5,0.6,0.9,0.6h4c0.6,0,1-0.4,1-1s-0.4-1-1-1h-1.6l2.3-2.3C21,16.4,21.1,16,20.9,15.6z"/>
    <path d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10c0.6,0,1-0.4,1-1s-0.4-1-1-1c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8c0,0.6,0.4,1,1,1 s1-0.4,1-1C22,6.5,17.5,2,12,2z"/>
    <path d="M13,8c-0.6,0-1,0.4-1,1v2.6l-2.7,2.7c-0.4,0.4-0.4,1,0,1.4C9.5,15.9,9.7,16,10,16s0.5-0.1,0.7-0.3l3-3 c0.2-0.2,0.3-0.4,0.3-0.7V9C14,8.4,13.6,8,13,8z"/>
  </svg>
</template>
